module.exports = __webpack_public_path__ + "img/other_xiaomi4.3e896fe2.jpg";